<div class="container mt-4">
    <div class="topNavH"></div>
    <div class="text-end mb-3">
      <app-settings-offcanvas></app-settings-offcanvas>
    </div>
    <h1  class=" mb-4 bigTitleCol">个人信息</h1>
    <p>这里将显示用户的个人信息。</p>
    </div>